<template>
  <div v-loading="state.loading" class="layout-navbars-breadcrumb-user-news">
    <div class="head-box">
      <div class="head-box-title">通知公告</div>
      <div class="head-box-btn" @click="readAll">全部已读</div>
    </div>
    <div v-loading="state.loading" class="content-box">
      <template v-if="newsList.length > 0">
        <div v-for="(v, k) in newsList" :key="k" class="content-box-item" @click="onNewsClick(k)">
          <div class="item-content">
            <div>{{ v.title }}</div>
            <div class="content-box-msg" v-html="v.content" @click="handleContentClick"></div>
            <div class="content-box-time">{{ v.time }}</div>
          </div>
          <!-- 已读/未读 -->
          <span v-if="v.read" class="el-tag el-tag--success el-tag--mini read">已读</span>
          <span v-else class="el-tag el-tag--danger el-tag--mini read">未读</span>
        </div>
      </template>
      <el-empty v-else :description="'消息为空'"></el-empty>
    </div>
    <!-- <div v-if="newsList.length > 0" class="foot-box" @click="onGoToClick">前往gitee</div> -->
  </div>
</template>

<script>
  import moment from 'moment'
  import {
    fetchList,
    updateStatus,
    countUnread
  } from '@/api/notice'
  export default {
    name: 'notice',
    props: {
      
    },
    data() {
      return {
        state: {
          loading: false
        },
        timer: null,
        newsList: [
          // {
          //   message: '欢迎使用朝阳联社管理系统',
          //   time: '2024-10-12 13:27',
          //   read: false
          // },
          // {
          //   message: '系统维护通知：今晚22:00-24:00进行系统维护',
          //   time: '2024-10-11 15:30',
          //   read: true
          // }
        ]
      }
    },
    created() {
      this.getNotice();
    },
    mounted() {
      this.startPolling();
    },
    beforeDestroy() {
      this.stopPolling();
    },
    methods: {
      getNotice() {
        fetchList().then(response => {
          if(response.data && response.data.list) {
            this.newsList = response.data.list.map(item => {
              return {
                id: item.id,
                title: item.title,
                content: item.content,
                time: moment(item.createTime).format('YYYY-MM-DD HH:mm'),
                read: item.status == 0 ? false : true
              }
            });
            this.$emit('updateUnreadCount', response.data.list.filter(item => item.status == 0).length);
            //弹框
            response.data.list.forEach(item => {
              let oneHourBefore = moment().subtract(1, 'hours');
              const noticeTime = moment(item.createTime);
              if(item.status == 0 && noticeTime.isAfter(oneHourBefore)) {
                this.$notify({
                  title: item.title,
                  dangerouslyUseHTMLString: true,
                  message: item.content,
                });
              }
            })
            
          }
        })
      },
      readAll() {
        const idList = this.newsList.map(item => item.id);
        let params = new URLSearchParams();
        params.append('ids', idList);
        updateStatus(params).then(response => {
          this.newsList.forEach(item => {
            item.read = true
          });
          this.$message.success('全部标记为已读');
          countUnread().then(subResponse => {
            this.$emit('updateUnreadCount', subResponse.data);
          })
        });
      },
      onNewsClick(index) {
        let item = this.newsList[index];
        let params = new URLSearchParams();
        params.append('ids', [item.id]);
        updateStatus(params).then(response => {
          item.read = true;
          countUnread().then(subResponse => {
            this.$emit('updateUnreadCount', subResponse.data);
          })
        });
      },
      onGoToClick() {
      },
      startPolling() {
        this.timer = setInterval(() => {
          this.getNotice();
        }, 60 * 1000); // 每1min拉取一次
      },
      stopPolling() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      },
      handleContentClick(event) {
        if (event.target.tagName === 'A') {
          event.preventDefault();
          const href = event.target.getAttribute('href');
          if (href) {
            window.open(href, '_blank');
          }
        }
      }
    }
  }
</script>

<style scoped>
  .layout-navbars-breadcrumb-user-news {
    width: 300px;
    max-height: 400px;
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
  }

  .head-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
  }

  .head-box-title {
    font-weight: 500;
    color: #303133;
  }

  .head-box-btn {
    color: #409eff;
    cursor: pointer;
    font-size: 12px;
  }

  .head-box-btn:hover {
    color: #66b1ff;
  }

  .content-box {
    max-height: 280px;
    overflow-y: auto;
  }

  .content-box-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 14px 16px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .content-box-item:hover {
    background-color: #f5f7fa;
  }

  .content-box-item:last-child {
    border-bottom: none;
  }

  .item-content {
    flex: 1;
    max-width: 222px;
  }

  .item-content > div:first-child {
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .content-box-msg {
    color: #606266;
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 6px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .content-box-time {
    color: #909399;
    font-size: 12px;
  }

  .read {
    margin-left: 8px;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .foot-box {
    padding: 8px 16px;
    text-align: center;
    background: #fafafa;
    color: #409eff;
    cursor: pointer;
    border-top: 1px solid #f0f0f0;
    font-size: 12px;
  }

  .foot-box:hover {
    background: #ecf5ff;
  }
</style>


// WEBPACK FOOTER //
// src/components/Notice/index.vue